import { PreSimulatorModel } from './pre-simulator.model';

class HolderEmploymentData {
  monthlyIncome: string;
  otherIncome: string;
  employmentSituation: string;
  companyName: string;
  laborSeniority: string;
  activitySector: string;
  academicLevel: string;
  professionalLevel: string;

  constructor() {
    this.monthlyIncome = '';
    this.employmentSituation = '';
    this.companyName = '';
    this.laborSeniority = '';
    this.activitySector = '';
    this.academicLevel = '';
    this.professionalLevel = '';
  }
}

class HolderAddress {
  roadType: string;
  roadName: string;
  roadNumber: string;
  doorway: string;
  floor: string;
  door: string;
  zip: string;
  city: string;

  constructor() {
    this.roadType = '';
    this.roadName = '';
    this.roadNumber = '';
    this.doorway = '';
    this.floor = '';
    this.door = '';
    this.zip = '';
    this.city = '';
  }
}

export class Holder {
  idType: string;
  idNumber: string;
  name: string;
  firstSurname: string;
  secondSurname: string;
  birthDate: any;
  maritalStatus: string;
  economicRegimeBeforeDivorce: string;
  email: string;
  phone: string;
  isPrimaryHolder: boolean;
  holderEmploymentData: HolderEmploymentData;
  holderAddress: HolderAddress;
  gender: string;
  nationality: string;
  country: string;

  constructor() {
    this.idType = '';
    this.idNumber = '';
    this.name = '';
    this.firstSurname = '';
    this.secondSurname = '';
    this.birthDate = '';
    this.maritalStatus = '';
    this.economicRegimeBeforeDivorce = '';
    this.email = '';
    this.phone = '';
    this.isPrimaryHolder = false;
    this.holderEmploymentData = new HolderEmploymentData();
    this.holderAddress = new HolderAddress();
  }
}
export class EconomicStudyData {
  email?: string;
  isMore2Holders: boolean;
  expensesOtherLoad: string;
  membersFamily: string;
  holders: Array<Holder>;
  titularNumber?: string;
  signatureDate: any;
  postCode: string;
  squareMeters: string;
  isSubsidizedHousing: boolean;
  constructor() {
    this.isMore2Holders = false;
    this.isSubsidizedHousing = false;
    this.expensesOtherLoad = '';
    this.membersFamily = '';
    this.holders = [new Holder()];
    this.titularNumber = '1';

    this.signatureDate = '';
    this.postCode = '';
    this.squareMeters = '';
  }
}

export class UserDataModel {
  id: string;
  status: string;
  level1Data: PreSimulatorModel;
  level2Data: EconomicStudyData; // AdvanceSimulatorModel;

  constructor() {
    this.level1Data = new PreSimulatorModel();
    this.level2Data = new EconomicStudyData();
  }
}
